import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const SummaryCards = ({ summary }) => {
  const formatDuration = (minutes) => {
    const mins = Math.floor(minutes);
    const secs = Math.round((minutes - mins) * 60);
    return `${mins}m ${secs}s`;
  };

  return (
    <div className="container">
      <div className="g-4 row">
        {/* Card 1: Total Users */}
        <div className="col-lg-3 col-md-6 col-sm-12">
          <div
            className="card border-0 h-100 shadow-md"
            style={{ borderRadius: "10px" }}
          >
            <div className="d-flex flex-column card-body align-items-start">
              <h4
                className="card-title rounded-2 mb-3 px-2 py-1"
                style={{
                  backgroundColor: "#e6f0fa",
                  color: "#1a73e8",
                  display: "inline-block",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Total Users
              </h4>
              <span
                className="mb-2"
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                {summary && summary.length ? summary[0].total_users : 0}
              </span>
            </div>
          </div>
        </div>

        {/* Card 2: Avg Session Duration */}
        <div className="col-lg-3 col-md-6 col-sm-12">
          <div
            className="card border-0 h-100 shadow-md"
            style={{ borderRadius: "10px" }}
          >
            <div className="d-flex flex-column card-body align-items-start">
              <h4
                className="card-title rounded-2 mb-3 px-2 py-1"
                style={{
                  backgroundColor: "#e6f0fa",
                  color: "#1a73e8",
                  display: "inline-block",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Avg. Session Duration
              </h4>
              <span
                className="mb-2"
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                {summary && summary.length
                  ? formatDuration(summary[0].avg_session_duration_minutes)
                  : "0m 0s"}
              </span>
            </div>
          </div>
        </div>

        {/* Card 3: Team Views */}
        <div className="col-lg-3 col-md-6 col-sm-12">
          <div
            className="card border-0 h-100 shadow-md"
            style={{ borderRadius: "10px" }}
          >
            <div className="d-flex flex-column card-body align-items-start">
              <h4
                className="card-title rounded-2 mb-3 px-2 py-1"
                style={{
                  backgroundColor: "#e6f0fa",
                  color: "#1a73e8",
                  display: "inline-block",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Total Team Views
              </h4>
              <span
                className="mb-2"
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                {summary && summary.length ? summary[0].total_team_views : 0}
              </span>
            </div>
          </div>
        </div>

        {/* Card 4: Team Updates */}
        <div className="col-lg-3 col-md-6 col-sm-12">
          <div
            className="card border-0 h-100 shadow-md"
            style={{ borderRadius: "10px" }}
          >
            <div className="d-flex flex-column card-body align-items-start">
              <h4
                className="card-title rounded-2 mb-3 px-2 py-1"
                style={{
                  backgroundColor: "#e6f0fa",
                  color: "#1a73e8",
                  display: "inline-block",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Total Team Updates
              </h4>
              <span
                className="mb-2"
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                {summary && summary.length ? summary[0].total_team_updates : 0}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryCards;
